<template>
  <div class="tw-flex tw-flex-col tw-gap-16 tw-overflow-y-auto scrollbar-hide tw-px-4 tablet:tw-px-20 tw-min-w-[300px]">
    <!-- Cookie Policy -->
    <div class="tw-flex tw-flex-col tw-gap-8 tw-pb-[112px] tw-border-b dark:tw-border-ap-dim-grey tw-border-ap-gainsboro">
      <h1 class="tw-text-h2-bold-mobile apDesktop:tw-text-h2-bold-desktop">
        {{ $t('cookie_policy') }}
      </h1>
      <p
        class="tw-text-body-mobile apDesktop:tw-text-body-desktop tw-text-ap-nobel"
        v-html="$t('cookie_policy_desc')"
      />
    </div>
    <!-- Cookie Policy Content -->
    <div class="tw-flex tw-flex-col tw-gap-20">
      <!-- What are Cookies? -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h1 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop">
          {{ $t('what_are_cookies') }}
        </h1>
        <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('what_are_cookies_desc')" />
      </div>

      <!-- Why do we use cookies -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h1 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop">
          {{ $t('why_do_we_use_cookies') }}
        </h1>
        <p
          class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
          v-html="$t('why_do_we_use_cookies_desc')"
        />
      </div>

      <!-- Type of cookies -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h1 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop">
          {{ $t('types_of_cookies') }}
        </h1>
        <div class="tw-flex tw-flex-col tw-gap-16">
          <p
            class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
            v-html="$t('types_of_cookies_desc')"
          />
          <!-- ul list -->
          <div class="tw-flex tw-flex-col tw-gap-2 tw-pl-5">
            <ul class="tw-list-disc tw-list-outside ">
              <li class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop">{{
                $t('essential_cookies') }}</li>
            </ul>
            <p>{{ $t('essential_cookies_desc') }}</p>
          </div>
          <div class="tw-flex tw-flex-col tw-gap-2 tw-pl-5">
            <ul class="tw-list-disc tw-list-outside ">
              <li class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop">{{
                $t('performance_and_functionality_cookies') }}</li>
            </ul>
            <p>{{ $t('performance_and_functionality_cookies_desc') }}</p>
          </div>
          <div class="tw-flex tw-flex-col tw-gap-2 tw-pl-5">
            <ul class="tw-list-disc tw-list-outside ">
              <li class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop">{{
                $t('analytics_and_customisation_cookies') }}</li>
            </ul>
            <p>{{ $t('analytics_and_customisation_cookies_desc') }}</p>
          </div>
          <div class="tw-flex tw-flex-col tw-gap-2 tw-pl-5">
            <ul class="tw-list-disc tw-list-outside ">
              <li class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop">{{
                $t('social_networking_cookies') }}</li>
            </ul>
            <p>{{ $t('social_networking_cookies_desc') }}</p>
          </div>
        </div>
      </div>

      <!-- How Can I Control Cookies? -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h1 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop">
          {{ $t('how_can_i_control_cookies') }}
        </h1>
        <p
          class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
          v-html="$t('how_can_i_control_cookies_desc')"
        />
      </div>

      <!-- How Can I Control Cookies? -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h1 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop">
          {{ $t('what_about_other_tracking_technologies') }}
        </h1>
        <p
          class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
          v-html="$t('what_about_other_tracking_technologies_desc')"
        />
      </div>

      <!-- Where Can I Get Further Information? -->
      <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-20">
        <h1 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop">
          {{ $t('where_can_i_get_further_information') }}
        </h1>
        <p
          class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
          v-html="$t('where_can_i_get_further_information_desc', {
            email: '<a href=\'mailto:hello+privacy@the-next.co\'>hello+privacy@the-next.co</a>'
          })"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'cookie-policy',
};
</script>